import React, {useContext, useEffect, useState} from "react";
import {directusContext} from "../../app/DirectusProvider";
import {useNavigate} from "react-router-dom";
import AuthForm from "../common/AuthForm";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const LoginForm = () => {
    const {directus, updateVersion, setCurrentUser} = useContext(directusContext);
    const {t} = useTranslation();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        directus.auth.login({email: email, password: password}).then(() => {
            directus.users.me.read({fields: ["*", "role.*"]}).then(resp => {
                setCurrentUser(resp);
                updateVersion();
                navigate("/cours");
            });
        }).catch(() => {
            toast.error(t("auth.loginFail"));
        });
    };

    useEffect(() => {
        if (directus.auth.token) {
            directus.users.me.read({fields: ["*", "role.*"]}).then((resp) => {
                setCurrentUser(resp)
                navigate("/");
            }).catch(() => {
                directus.auth.logout().finally(() => {
                    localStorage.clear();
                    setCurrentUser(null);
                });
            });
        } else {
            directus.auth.refresh().then(() => {
                directus.users.me.read({fields: ["*", "role.*"]}).then((resp) => {
                    setCurrentUser(resp)
                    navigate("/");
                });
            });
        }
    }, [directus, navigate, setCurrentUser]);

    return (
        <AuthForm
            handleSubmit={handleSubmit}
            buttonText={t("auth.login")}
            showPasswordReset={true}
            input1={{
                id: "email",
                type: "email",
                label: t("auth.email"),
                placeholder: "mail@gmail.com",
                required: true,
                value: email,
                onChange: (e) => setEmail(e.target.value)
            }}
            input2={{
                id: "password",
                type: "password",
                label: t("auth.password"),
                placeholder: "********",
                required: true,
                value: password,
                onChange: (e) => setPassword(e.target.value)
            }}/>
    );
};

export default LoginForm;
